<template>
  <div class="am-quantity">
    <div class="quantity">
      <AmButton
        :class="['quantity__remove', theme.color, `button__outlined--${theme.color}`]"
        type="outlined"
        size="sm"
        :icon="iconRemove"
        :disabled="disabledCheckRemove || loadingCart"
        @click="remove"
      />
      <input
        v-model="quantity"
        :min="min"
        :max="max"
        type="number"
        class="quantity__input"
        :readonly="readonly"
        @change="change()"
        @input="checkVale($event)"
      />
      <AmButton
        :class="['quantity__add', theme.color, `button__outlined--${theme.color}`]"
        type="outlined"
        size="sm"
        :icon="iconAdd"
        :disabled="disabledAdd || loadingCart"
        @click="add"
      />
    </div>
  </div>
</template>

<script>
import themeMixin from '@/components/mixins/themeMixin'
import { mapState } from 'vuex'

export default {
  name: 'AmQuantity',
  mixins: [themeMixin],
  props: {
    value: {
      type: Number,
      default: () => 0,
    },
    min: {
      type: Number,
      default: () => 1,
    },
    max: {
      type: Number,
      default: () => 5000,
    },
    disabledRemove: {
      type: Boolean,
      default: () => false,
    },
    disabledAdd: {
      type: Boolean,
      default: () => false,
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      iconRemove: {
        name: 'remove',
        type: 'material',
        color: '#0083f3',
      },
      iconAdd: {
        name: 'add',
        type: 'material',
        color: '#0083f3',
      },
      disableCheckQuantityRemove: false,
    }
  },
  computed: {
    ...mapState('Checkout', {
      loadingCart: (state) => state.cartLoading,
    }),
    quantity: {
      get() {
        return this.value
      },
      set(newValue) {
        const parseValue = this.parseToNumber(newValue)
        this.$emit('input', parseValue)
      },
    },
    disabledCheckRemove() {
      return this.disableCheckQuantityRemove || this.disabledRemove
    },
  },
  watch: {
    quantity: {
      immediate: true,
      handler() {
        if (this.quantity === this.min) {
          this.disableCheckQuantityRemove = true
        } else {
          this.disableCheckQuantityRemove = false
        }
      },
    },
  },
  methods: {
    checkVale(event) {
      const number = this.parseToNumber(event.target.value)

      if (!number || number < this.min) {
        this.quantity = this.min
        event.target.value = this.min
      }

      if (number > this.max) {
        this.quantity = this.max
        event.target.value = this.max
      }
    },
    parseToNumber(newValue) {
      return parseInt(newValue, 10)
    },
    add() {
      if (this.quantity < this.max) {
        this.quantity += 1
        this.$emit('change')
      }
    },
    remove() {
      if (this.quantity > this.min) {
        this.quantity -= 1
        this.$emit('change')
      }
    },
    change() {
      this.$emit('change')
    },
  },
}
</script>

<style lang="scss" scoped>
.am-quantity {
  // Removendo as setas default do input tipo number
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
  .quantity {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 20px 0;
    &__remove,
    &__add {
      border-width: 1px;
      box-sizing: border-box;
      padding: 4px;
      ::v-deep {
        &.button-content .icon .am-icon .am-icon-material {
          font-size: 1.3em;
        }
      }
    }
    &__remove:disabled,
    &__add:disabled {
      border: solid $dark-40 1px !important;
      ::v-deep {
        &.button-content .icon .am-icon .am-icon-material {
          color: $dark-40 !important;
        }
      }
    }
    &__input {
      border: solid $dark-40 1px;
      width: 50px;
      height: 32px;
      border-radius: 6px;
      text-align: center;
      margin: 0 6px 0 6px;
      outline: none;
    }
  }
}
</style>
